export const GEOMETRY = 'geometry';